export default __webpack_public_path__ + "static/media/sql.efb7363b.svg";